window.PlummePostingDocumentation = (function initPostingDocumentation() {
  // Hvilke foeringer som allerede er dokumentert.
  //
  // En fri postering bokfoert fra bankavstemmingen har bankutskriften som sin
  // dokumentasjon, og bokfoeringsflyten krever da heller ikke eget bilag — bare
  // kjoep, salg, leverandoerfaktura og laan gjoer det. Kvalitetskontrollen brukte
  // likevel samme bilagskrav paa alt som ligger i `expenses`, og fri postering
  // ligger der av tekniske grunner. En overfoering mellom egne kontoer kom derfor
  // opp som «kjoep mangler bilag», med en tekst som ba brukeren aapne et kjoep som
  // ikke finnes.
  //
  // Regelen er smal med vilje: bare foeringer som faktisk er koblet til en
  // banklinje slipper unna. En fri postering skrevet inn for haand har ingen
  // dokumentasjon, og skal fortsatt telles.
  const safeArray = (value) => (Array.isArray(value) ? value : []);

  // Koblingen ligger to steder: paa foeringen (`bankTrace`) og paa banklinja
  // (`matchedEntryId`). Foeringer bokfoert for banksporet ble lagret har bare den
  // siste, saa begge maa leses.
  const bankDocumentedPostingIds = (state) => {
    const ids = new Set();
    safeArray(state?.bankStatements).forEach((statement) => {
      safeArray(statement?.lines).forEach((line) => {
        const id = String(line?.matchedEntryId || '').trim();
        if (id) ids.add(id);
      });
    });
    return ids;
  };

  const isBankDocumentedPosting = (expense, bankDocumentedIds) => {
    if (expense?.manualPosting !== true) return false;
    if (expense?.bankTrace?.lineId) return true;
    if (!bankDocumentedIds || typeof bankDocumentedIds.has !== 'function') return false;
    return bankDocumentedIds.has(String(expense?.id || ''));
  };

  return { bankDocumentedPostingIds, isBankDocumentedPosting };
})();
